import { render, staticRenderFns } from "./ListAreas.vue?vue&type=template&id=daf37872&scoped=true"
import script from "./ListAreas.vue?vue&type=script&lang=js"
export * from "./ListAreas.vue?vue&type=script&lang=js"
import style0 from "./ListAreas.vue?vue&type=style&index=0&id=daf37872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf37872",
  null
  
)

export default component.exports